<template>
    <main>
        <PromotionEditDialog ref="promotionDialog"/>
        <v-table
            id="mainTbl"
            request-uri="promotions/published/getList"
            pagesize="50"
            ref="table"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="clinicName" width="400">
                        Клиника
                    </v-th>
                    <v-th name="name" sort="name" minwidth="200">
                        Название
                    </v-th>
                    <v-th name="promotionsActivity" width="75">
                        Период
                    </v-th>
                    <v-th name="discount" width="75">
                        Скидка
                    </v-th>
                </v-tr>

                <v-tr>
                    <v-th name="clinicName" :debounce="true" v-slot="{filter}" width="400">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="name" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="promotionsActivity" v-slot="{filter}" width="75">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                   value: "willBegin",
                                   text: "Запланирована"
                                },
                                                        {
                                   value: "active",
                                   text: "Активна"
                                },
                                {
                                    value: "ended",
                                    text: "Закончилась"
                                },
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="discount" v-slot="{filter}" width="75">
                        <v-input v-model="filter.value"/>
                    </v-th>

                </v-tr>

            </template>

            <template v-slot:row="{ item, index, indexOnPage }">
                <v-tr :class="['hover', 'pointer']" @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td name="clinicName" width="400">
                        <div v-for="clinic in item.clinics" :class="[{'warning': clinic.isModerationSource}]">
                            <div class="text-ellipsis">
                                {{clinic.name}}
                            </div>
                        </div>
                        <div v-for="network in item.networkModerationSources" class="warning">
                            <div class="text-ellipsis">
                                Сетевой Аккаунт ({{network.name}})
                            </div>
                        </div>
                    </v-td>
                    <v-td name="name">
                        <span>{{ item.name }}</span>
                    </v-td>
                    <v-td name="promotionsActivity" highlight="*" width="75">
                        {{item.dateFrom | formatDatePeriodShort(item.dateTill) }}
                    </v-td>
                    <v-td name="discount" highlight="*" width="75" align="center">
                        <span>{{ item.discount? item.discount+' %': '-' }}</span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>
<script>
import PromotionEditDialog from "@/components/dialogs/PromotionEditDialog";

export default {
    components:{PromotionEditDialog},
    methods: {
        handleRowClick(event, row, item) {
            row.startLoadingAnimation();
            this.axios.get('/admin/moderation/promotions/published/read/' + item.id)
                .then(response => {
                    this.$refs.promotionDialog.read(response.data.data, response.data.data.city, response.data.data.url)
                    row.stopLoadingAnimation()
                })
                .catch(() => row.stopLoadingAnimation());
        },
    }
}
</script>
<style>

</style>
